"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _SailSchedule = _interopRequireDefault(require("@/components/SailSchedule"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    sailSchedule: _SailSchedule.default
  },
  props: {
    templateType: {
      type: String,
      default: null
    },
    form: {
      type: Object
    },
    cargoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bookingTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    transportationTermsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paidTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Object
    },
    packageTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  data: function data() {
    return {
      sailScheduleDialogVisible: false,
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: '1',
        name: 'Reshipment'
      }],
      isSplitList: [{
        value: '0',
        labelEh: 'NO',
        labelZh: '否'
      }, {
        value: '1',
        labelEh: 'YES',
        labelZh: '是'
      }],
      documentTypeList: [{
        value: '0',
        labelZh: '提单',
        labelEh: 'BILL OF LADING'
      }, {
        value: '1',
        labelZh: '海运提单',
        labelEh: 'SEA WAYBILL'
      }]
    };
  },
  mounted: function mounted() {
    //   setTimeout(()=>{
    //     this.vessNameVoy = this.form.vesselCode + '.' + this.form.voyageNo + ' ' +  this.form.voyageLeg
    //       console.log(this.vessNameVoy,'this.vessNameVoy')
    //       if(this.form.webBkYardComs.length===0){
    //          this.form.webBkYardComs.push({pickupYard:'',returnYard:'',pickupDate:''})
    //       }
    //   },1000)
  },
  methods: {
    handleSelectVessel: function handleSelectVessel() {
      console.log('handleSelectVessel');
      this.sailScheduleDialogVisible = true;
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.form.vesselCode = row.vesselCode;
      this.form.vesselName = row.vesselName;
      this.form.voyageNo = row.voyageNo;
      this.form.voyageLeg = row.voyageLeg;
      this.form.serviceLineCode = row.serviceLineCode;
    },
    changeDel: function changeDel(row, val) {
      this.form.delName = val.portName;
      this.form.webBkExtendComs[0].delName = val.portName;
    },
    changePol: function changePol(row, val) {
      this.form.porName = val.portName;
      this.form.webBkExtendComs[0].porName = val.portName;
    }
  }
};